import React, { Suspense } from "react";
import { Parallax, Background } from "react-parallax";
import Laptop from "../../assets/laptop.svg";
import LaptopMobile from "../../assets/laptop-mobile-version.png";
import { SuspenseImg } from "../../helpers/SuspenseImg";
import { Link } from "react-router-dom";

const Intro = () => {
  return (
    <section className="intro-banner">
      <div className="container sm:container md:container lg:container w-full mx-auto">
        <div className="grid sm:grid-flow-row md:grid-flow-col md:grid-cols-2 grid-cols-1 gap-4 pt-4 pb-0 md:py-16 flex flex-col md:flex-row items-center">
          <div>
            <h3 className="text-2xl md:text-3xl font-avenirLight text-Gray-900">
              Diverse software company
            </h3>
            <h1 className="font-normal text-3xl md:text-5xl md:py-4 py-2 leading-tight font-avenirHeavy text-Gray-900 mobile-text">
              We provide outstanding digital solutions
            </h1>

            <div className="md:hidden block">
              <Suspense fallback={<div className="intro-loader"></div>}>
                <SuspenseImg alt="" className="mx-auto" src={LaptopMobile} />
              </Suspense>
            </div>
            <p className="font-light text-base md:text-xl font-avenirBook pt-1 text-Gray-600">
              by creating innovative products with cutting edge technologies
            </p>
            <Link to="/about">
              <button
                className="brand-primary-btn mt-10 transition transform"
                aria-label="Know more"
              >
                Know more
              </button>
            </Link>
          </div>

          <>
            <div className="md:block hidden">
              <div className="flex flex-col justtify-end lg:block hidden">
                <Parallax
                  strength={150}
                  className="w-full h-full"
                  style={{ height: 500 }}
                >
                  <Background className="custom-bg w-full">
                    <Suspense fallback="Loading...">
                      <SuspenseImg alt="" className="mx-auto" src={Laptop} />
                    </Suspense>
                  </Background>
                </Parallax>
              </div>
              <div className="flex flex-col justtify-end lg:hidden block">
                <Parallax
                  strength={50}
                  className="w-full h-full"
                  style={{ height: 450 }}
                >
                  <Background className="custom-bg w-full">
                    <Suspense fallback="Loading...">
                      <SuspenseImg alt="" className="mx-auto" src={Laptop} />
                    </Suspense>
                  </Background>
                </Parallax>
              </div>
            </div>
          </>
        </div>
      </div>
    </section>
  );
};

export default Intro;
